import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Switch } from '@mui/material';

function ChekboxInput({
  id,
  value,
  onChange,
  disabled,
}) {
  return (
    <Switch
      id={id}
      checked={value}
      onChange={(e, v) => onChange(e, v)}
      color="primary"
      disabled={disabled}
    />
  );
}

ChekboxInput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

ChekboxInput.defaultProps = {
  id: null,
  disabled: null,
  value: false,
};

export default memo(ChekboxInput);
